import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  currentApp: null,
  secondApp: null,
  searchTerm: '',
  countryCode: 'us',
});

export default function itunesSearchReducer(state = initState, action) {
  switch (action.type) {
    case actions.COLLPSE_CHANGE:
      return state.set('collapsed', !state.get('collapsed'));
    case actions.COLLPSE_OPEN_DRAWER:
      return state.set('openDrawer', !state.get('openDrawer'));
    case actions.TOGGLE_ALL:
      if (state.get('view') !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        return state
          .set('collapsed', action.collapsed)
          .set('view', action.view)
          .set('height', height);
      }
      break;
    case actions.CHANGE_OPEN_KEYS:
      return state.set('openKeys', action.openKeys);

    case actions.CHANGE_CURRENT:
      return state.set('current', action.current);

    case actions.SET_CURRENT_APP:
      return state
        .set('currentApp', action.app)
        .set('secondApp', action.secondApp);

    case actions.SET_SEARCH_TERM:
      return state
        .set('searchTerm', action.searchTerm)

    case actions.SET_COUNTRY_CODE:
      return state
        .set('countryCode', action.countryCode)
        
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/itunesSearch/reducer.js